import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ICasinoGamesIconProps extends ISvgIconProps {

}

export class CasinoGamesIcon extends React.Component<ICasinoGamesIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5">
                    <path d="M17.583 6.927c3.338.862 5.583 2.471 5.583 4.315 0 2.751-5 4.982-11.166 4.982S.834 13.993.834 11.242c0-1.849 2.257-3.463 5.61-4.322"/>
                    <path d="M23.165 11.242v4.959c0 2.751-5 4.982-11.166 4.982S.834 18.956.834 16.201v-5.395"/>
                    <path d="M11.754 12.079V7.685"/>
                    <path d="M7.886 5.543h2.85"/>
                    <path strokeLinecap="round" d="M7.856 4.81v1.466"/>
                    <path d="M16.113 5.543h-2.859"/>
                    <path strokeLinecap="round" d="M16.144 6.276V4.81"/>
                    <path d="M12 2.845v1.719"/>
                    <path strokeLinecap="round" d="M12.734 2.814h-1.467"/>
                    <path d="M4.638 12.342c0-1.677 2.818-3.06 6.456-3.259"/>
                    <path d="M19.361 12.342c0-1.677-2.818-3.06-6.456-3.259"/>
                </g>
            </SvgIcon>
        );
    }
}
